<template>
  <v-dialog v-model="visibility" persistent max-width="400px" :retain-focus="false">
    <v-card v-if="visibility" class="rounded-xl py-2">
      <!-- Title -->
      <v-card-title class="pa-6">
        <h4 v-if="type === 'mrc'" class="text-capitalize dialog-title">{{ t('$vuetify.__General.delete') }} {{ item.filename }}</h4>
        <h4 v-else-if="type === 'avatar'" class="text-capitalize dialog-title">{{ t('$vuetify.__General.delete') }} {{ item.name }}</h4>
        <h4 v-else-if="type === 'event'" class="text-capitalize dialog-title">{{ t('$vuetify.__General.delete') }} {{ t('$vuetify.__EventManager.event') }}</h4>
        <h4 v-else-if="type === 'quiz_question'" class="text-capitalize dialog-title">{{ t('$vuetify.__General.delete') }} {{ t('$vuetify.__DeleteDialog.question') }}</h4>
        <h4 v-else-if="type === 'idle_video'" class="text-capitalize dialog-title">{{ t('$vuetify.__General.delete') }} {{ t('$vuetify.__General.video') }}</h4>
        <h4 v-else-if="type === 'location'" class="text-capitalize dialog-title">{{ t('$vuetify.__General.delete') }} Location</h4>
        <h4 v-else-if="type === 'category_layer'" class="text-capitalize dialog-title">{{ t('$vuetify.__General.delete') }} Category</h4>

        <h4 v-else class="text-capitalize dialog-title">{{ t('$vuetify.__General.delete') }} {{ t(`$vuetify.__DeleteDialog.${type}`) }} {{ t('$vuetify.__DeleteDialog.record') }}?</h4>
      </v-card-title>

      <!-- Hint -->
      <v-card-text v-if="type === 'avatar'">{{ t('$vuetify.__DeleteDialog.avatar_hint') }}</v-card-text>
      <v-card-text v-else-if="type === 'quiz'">{{ t('$vuetify.__DeleteDialog.quiz_hint') }}</v-card-text>
      <v-card-text v-else-if="type === 'question' || type === 'quiz_question'">{{ t('$vuetify.__DeleteDialog.question_hint') }}</v-card-text>
      <v-card-text v-else-if="type === 'location' || type === 'category_layer'"></v-card-text>
      <v-card-text v-else>{{ t('$vuetify.__DeleteDialog.record_hint') }} </v-card-text>

      <!-- Action buttons -->
      <v-card-actions class="px-6 py-4">
        <v-spacer></v-spacer>
        <v-btn variant="outlined" rounded :disabled="submit_btn_disable" class="text-capitalize px-3" @click="store.commit('RESET_DELETE_ITEM_DIALOG')">
          {{ t('$vuetify.__General.cancel') }}
        </v-btn>
        <v-btn color="#CF321D" rounded :dark="!submit_btn_disable" :disabled="submit_btn_disable" class="text-capitalize px-3" variant="flat" @click="store.dispatch('deleteItem')">
          {{ t('$vuetify.__General.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'
import { useLocale } from 'vuetify'
import { useStore } from 'vuex'
const { t } = useLocale()
const store = useStore()

const submit_btn_disable = computed(() => store.state.deleteItemDialog.submit_btn_disable)
const visibility = computed(() => store.state.deleteItemDialog.visibility)
const type = computed(() => store.state.deleteItemDialog.type)
const item = computed(() => store.state.deleteItemDialog.item)
</script>
